/**
 * Constructs a URL by replacing placeholders in the template with values from the params object.
 *
 * @param {string} hrefTemplate - The URL template containing placeholders in the format {key}.
 * @param {{ [key: string]: string }} params - An object containing key-value pairs to replace the placeholders.
 * @returns {string} - Return constructed URL.
 * */
const constructFromTemplate = (hrefTemplate, params) => {
    const regex = /{(\w+)}/g;
    return hrefTemplate.replace(regex, (match, param) => params[param] || '');
};
export default constructFromTemplate;
